/**
 * Limpieza de las cookies de sesión del ciudadano.
 *
 * Vive en un módulo sin dependencias para que pueda importarse tanto desde
 * login_logic como desde sessionExpiration sin crear ciclos de módulos
 * (login_logic → NewClassRequest → sessionExpiration → login_logic).
 */
import Cookies from 'js-cookie';

export function destroyCookies() {
  Cookies.remove('client_02', { path: '/' });
  Cookies.remove('uid_02', { path: '/' });
  Cookies.remove('token_02', { path: '/' }); // removed!
  Cookies.remove('userId_02', { path: '/' }); // removed!
  Cookies.remove('names_02', { path: '/' }); // removed!
  Cookies.remove('regime_02', { path: '/' }); // removed!
  Cookies.remove('paternal_surname_02', { path: '/' });
  Cookies.remove('isAuth_02', { path: '/' });
  Cookies.remove('avatar_02', { path: '/' });
  Cookies.remove('authentication_token_02', { path: '/' });
  Cookies.remove('app_config', { path: '/' });
}
